import i18next from 'i18next';
import { ModifiedArray } from 'infrastructure/classes/common/modified-array';
import {
  ClinicDoNotCallRestrictionType,
  DoNotCallRestrictionType,
} from 'infrastructure/enums';

export interface IDoNotCallRestrictionTypeItem {
  id: DoNotCallRestrictionType | ClinicDoNotCallRestrictionType | null;
  name: string;
}

type ModifiedArrayType = ModifiedArray<IDoNotCallRestrictionTypeItem>;

export const doNotCallRestrictionTypeDataSource = ({
  withNull,
  type,
}: {
  withNull?: boolean;
  type: 'clinic' | 'patient';
}): ModifiedArrayType => {
  const dataSource: ModifiedArrayType = new ModifiedArray(
    {
      id: DoNotCallRestrictionType.FullRestriction,
      name: i18next.t('doNotCallRestrictionType.fullRestriction'),
    },
    {
      id: DoNotCallRestrictionType.LimitedHours,
      name: i18next.t('doNotCallRestrictionType.limitedHours'),
    },
  );

  if (type === 'clinic') {
    dataSource.push({
      id: ClinicDoNotCallRestrictionType.InheritParentClinic,
      name: i18next.t('doNotCallRestrictionType.inheritParentClinic'),
    });
  }

  if (withNull) {
    dataSource.unshift({
      id: null,
      name: i18next.t('labels.none'),
    });
  }

  return dataSource;
};
